
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/troops",
      function () {
        return require("private-next-pages/troops/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/troops"])
      });
    }
  